import React from 'react';
import {shape, func} from 'prop-types';
import classNames from 'classnames';
import {default as Checkbox} from '@sinclair-digital/sbg-storyline-components/src/components/forms/Checkbox';
import {tagShape} from '../../models/common/tagModel';
import styles from './Tag.scss';
import {SOURCE_USERGENERATED} from '../../constants/tags';

const AutoGeneratedTag = ({onChange, tag}) => {
    const className = classNames(styles.Tag, {
        [styles['Tag--locked']]: tag.removable === false,
        'is-sda-tagDraggable': tag.draggable,
        [styles.excluded]: !tag.included,
    });
    // set strength of relationship
    const weightPercent = Math.floor(tag.weight * 100) + '%';
    return (
        <div className={className}>
            <div className={styles.name}>
                {tag.name}
                <Checkbox checked={tag.included} onChange={onChange} className={styles['included-checkbox']} />
            </div>
            <div className={styles.dimension}>
                {tag.dimension}
                <span className={styles['weight-text']}>{weightPercent}</span>
            </div>
            <div className={styles.weight} style={{width: weightPercent}} />
        </div>
    );
};

const UserGeneratedTag = ({onChange, tag}) => {
    const className = classNames(styles.Tag, styles['Tag--user-generated'], {
        [styles['Tag--locked']]: tag.removable === false,
        [styles['is-sda-tagDraggable']]: tag.draggable,
        [styles.excluded]: !tag.included,
    });
    return (
        <div className={className}>
            <div className={styles.name}>{tag.name}</div>
            <div className={styles.dimension}>
                {tag.dimension}
                {tag.removable ? (
                    <a className={classNames('fa-times', styles['remove-tag'])} onClick={onChange} />
                ) : (
                    <i className={classNames('fa-lock', styles['fa-lock'])} />
                )}
            </div>
        </div>
    );
};

const SimpleTag = ({onChange, tag}) => (
    <div className={styles.Tag}>
        <div className={styles.name}>
            {tag.name}
            <Checkbox checked={tag.included} onChange={onChange} className={styles['included-checkbox']} />
        </div>
    </div>
);

const TagFacade = ({tag, onChange}) => {
    if (tag.source === SOURCE_USERGENERATED) {
        return <UserGeneratedTag tag={tag} onChange={onChange} />;
    }

    return <AutoGeneratedTag tag={tag} onChange={onChange} />;
};
TagFacade.propTypes = {
    tag: shape(tagShape).isRequired,
    onChange: func.isRequired,
};

UserGeneratedTag.propTypes = AutoGeneratedTag.propTypes = SimpleTag.propTypes = TagFacade.propTypes;

export {TagFacade as default, TagFacade as Tag, TagFacade, UserGeneratedTag, AutoGeneratedTag, SimpleTag};
